import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { black } from "designSystem/styles/color";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import Text from "designSystem/components/text/Text";
import React from "react";
import { SelectedChannel } from "../../types";
import * as api from "../api";
import ChannelsList from "./ChannelsList";

interface Props {
	myChannels: api.Conversation[];
	otherConnectedChannels: api.Conversation[];
	onSelectChannel?: (channel: SelectedChannel) => void;
}

const ShowAllConnectedChannels: React.FunctionComponent<Props> = ({ myChannels, otherConnectedChannels, onSelectChannel }) => {
	return (
		<Grid
			alignItems="stretch"
			container
			direction="column"
			justifyContent="flex-start"
			style={{ width: "100%", boxSizing: "border-box" }}
		>
			<Grid item>
				<Box
					pb={2}
					pt={3}
					px={3}
				>
					<Text
						bold
						lineHeight={15}
						res="ConnectedChannelsTitle"
						size={12}
						style={{ color: black[100] }}
					/>
				</Box>
			</Grid>
			<Grid item style={{ width: "100%", boxSizing: "border-box" }}>
				<Box borderBottom={STANDARD_BORDER_STYLE} style={{ width: "100%", boxSizing: "border-box" }}>
					<ChannelsList channels={myChannels} onNavigateChannel={onSelectChannel} />
				</Box>
			</Grid>
			<Grid item>
				<Box
					pb={2}
					pt={3}
					px={3}
				>
					<Text
						bold
						lineHeight={15}
						res="OtherSlackConnectedChannelsTitle"
						size={12}
						style={{ color: black[100] }}
					/>
				</Box>
			</Grid>
			<Grid item style={{ width: "100%", boxSizing: "border-box" }}>
				<Box borderBottom={STANDARD_BORDER_STYLE} style={{ width: "100%", boxSizing: "border-box" }}>
					<ChannelsList channels={otherConnectedChannels} onNavigateChannel={onSelectChannel} />
				</Box>
			</Grid>
		</Grid>
	);
};

export default ShowAllConnectedChannels;